var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_InternationalBill"),
            width: _vm.isZh ? "1000px" : "1100px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expandedGrid,
                  expression: "expandedGrid"
                }
              ],
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "flex-grow": "1",
                    display: "flex",
                    "flex-direction": "column"
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": "left",
                        "label-width": _vm.isZh ? "90px" : "135px",
                        model: _vm.billing
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.MainOffice") } },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.mainOfficeChineseName,
                                placement: "bottom"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t("Message.PleaseSelect"),
                                    clearable: false,
                                    size: "mini"
                                  },
                                  model: {
                                    value: _vm.mainOffice,
                                    callback: function($$v) {
                                      _vm.mainOffice = $$v
                                    },
                                    expression: "mainOffice"
                                  }
                                },
                                _vm._l(_vm.officeList, function(office) {
                                  return _c(
                                    "el-tooltip",
                                    {
                                      key: office.uuid,
                                      attrs: {
                                        content: office.chineseName,
                                        placement: "left"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          value: office.officeId,
                                          label: office.code
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BillNo") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.billing.billingNo,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "billingNo", $$v)
                              },
                              expression: "billing.billingNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BillType") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.billingArDesc,
                              callback: function($$v) {
                                _vm.billingArDesc = $$v
                              },
                              expression: "billingArDesc"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BillAmount") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.billing.taxAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "taxAmount", $$v)
                              },
                              expression: "billing.taxAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CurrencyRequirements")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "200px",
                                  "padding-right": "10px"
                                },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.currencyRequirement,
                                  callback: function($$v) {
                                    _vm.currencyRequirement = $$v
                                  },
                                  expression: "currencyRequirement"
                                }
                              }),
                              !_vm.billing.uuid &&
                              _vm.customerDetail.currencyRequirements === 3
                                ? _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { display: "block" },
                                      attrs: { no: "splitBill" },
                                      on: { change: _vm.splitBillChangeEvent },
                                      model: {
                                        value: _vm.splitBillButton,
                                        callback: function($$v) {
                                          _vm.splitBillButton = $$v
                                        },
                                        expression: "splitBillButton"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Message.SplitBill")) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        padding: "2px 0"
                      }
                    },
                    [
                      _c(
                        "div",
                        { style: _vm.isZh ? "width:65px;" : "width:95px;" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Billing.billingJob_originalCurrency")
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        {
                          style:
                            (_vm.isZh ? "width:95px;" : "width:100px;") +
                            "margin-left: 5px;"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("Billing.billingJob_amountOfMoney"))
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { width: "95px", "margin-left": "20px" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("Billing.billing_exchangeRate"))
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { width: "95px", "margin-left": "30px" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Billing.billingJob_billAndCurrency")
                              )
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.splitBillButton,
                              expression: "splitBillButton"
                            }
                          ],
                          staticStyle: { width: "95px", "margin-left": "30px" }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Billing.billing_billAmount")))
                          ])
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        padding: "2px 0"
                      }
                    },
                    [
                      _c("el-input", {
                        style:
                          (_vm.isZh ? "width:65px;" : "width:95px;") +
                          "margin-right:5px",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.billing.sourceCurrency1,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "sourceCurrency1", $$v)
                          },
                          expression: "billing.sourceCurrency1"
                        }
                      }),
                      _c("el-input-number", {
                        style:
                          (_vm.isZh ? "width: 110px;" : "width: 115px;") +
                          "margin-right:5px",
                        attrs: {
                          "controls-position": "right",
                          min: -999999999999,
                          max: 999999999999,
                          precision: 2,
                          disabled: true
                        },
                        model: {
                          value: _vm.billing.amount1,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "amount1", $$v)
                          },
                          expression: "billing.amount1"
                        }
                      }),
                      _c("num-input", {
                        staticStyle: { width: "120px", "margin-right": "5px" },
                        attrs: {
                          min: 0,
                          max: 999999999999,
                          precision: 8,
                          "truncated-precision": _vm.sourceRate1Precision,
                          disabled: !_vm.sourceRateEnable.sourceRate1
                        },
                        on: { change: _vm.calculateAmount },
                        model: {
                          value: _vm.billing.sourceRate1,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "sourceRate1", $$v)
                          },
                          expression: "billing.sourceRate1"
                        }
                      }),
                      _c("cargo-advance-select", {
                        staticStyle: { width: "120px", "margin-right": "5px" },
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Currency,
                          "default-value": _vm.billing.currency,
                          clearable: false,
                          disabled: !_vm.unCommitOrPrint || _vm.splitBillButton
                        },
                        on: { parentCallBack: _vm.currencyChangeEvent }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.splitBillButton,
                            expression: "splitBillButton"
                          }
                        ],
                        staticStyle: { width: "120px" },
                        attrs: {
                          "controls-position": "right",
                          min: -999999999999,
                          max: 999999999999,
                          precision: 2,
                          disabled: true
                        },
                        model: {
                          value: _vm.billing.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "amount", $$v)
                          },
                          expression: "billing.amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        padding: "2px 0"
                      }
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.splitBillButton,
                            expression: "!splitBillButton"
                          }
                        ],
                        style:
                          (_vm.isZh ? "width:65px;" : "width:95px;") +
                          "margin-right:5px",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.billing.sourceCurrency2,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "sourceCurrency2", $$v)
                          },
                          expression: "billing.sourceCurrency2"
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.splitBillButton,
                            expression: "!splitBillButton"
                          }
                        ],
                        style:
                          (_vm.isZh ? "width: 110px;" : "width: 115px;") +
                          "margin-right:5px",
                        attrs: {
                          "controls-position": "right",
                          min: -999999999999,
                          max: 999999999999,
                          precision: 2,
                          disabled: true
                        },
                        model: {
                          value: _vm.billing.amount2,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "amount2", $$v)
                          },
                          expression: "billing.amount2"
                        }
                      }),
                      _c("num-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.splitBillButton,
                            expression: "!splitBillButton"
                          }
                        ],
                        staticStyle: { width: "120px", "margin-right": "5px" },
                        attrs: {
                          min: 0,
                          max: 999999999999,
                          precision: 8,
                          "truncated-precision": _vm.sourceRate2Precision,
                          disabled: !_vm.sourceRateEnable.sourceRate2
                        },
                        on: { change: _vm.calculateAmount },
                        model: {
                          value: _vm.billing.sourceRate2,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "sourceRate2", $$v)
                          },
                          expression: "billing.sourceRate2"
                        }
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.splitBillButton,
                              expression: "!splitBillButton"
                            }
                          ],
                          staticStyle: { width: "95px" }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Billing.billing_billAmount")))
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        padding: "2px 0"
                      }
                    },
                    [
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.splitBillButton,
                            expression: "!splitBillButton"
                          }
                        ],
                        style:
                          (_vm.isZh ? "width:65px;" : "width:95px;") +
                          "margin-right:5px",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.billing.sourceCurrency3,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "sourceCurrency3", $$v)
                          },
                          expression: "billing.sourceCurrency3"
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.splitBillButton,
                            expression: "!splitBillButton"
                          }
                        ],
                        style:
                          (_vm.isZh ? "width: 110px;" : "width: 115px;") +
                          "margin-right:5px",
                        attrs: {
                          "controls-position": "right",
                          min: -999999999999,
                          max: 999999999999,
                          precision: 2,
                          disabled: true
                        },
                        model: {
                          value: _vm.billing.amount3,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "amount3", $$v)
                          },
                          expression: "billing.amount3"
                        }
                      }),
                      _c("num-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.splitBillButton,
                            expression: "!splitBillButton"
                          }
                        ],
                        staticStyle: { width: "120px", "margin-right": "5px" },
                        attrs: {
                          min: 0,
                          max: 999999999999,
                          precision: 8,
                          "truncated-precision": _vm.sourceRate3Precision,
                          disabled: !_vm.sourceRateEnable.sourceRate3
                        },
                        on: { change: _vm.calculateAmount },
                        model: {
                          value: _vm.billing.sourceRate3,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "sourceRate3", $$v)
                          },
                          expression: "billing.sourceRate3"
                        }
                      }),
                      _c("el-input-number", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.splitBillButton,
                            expression: "!splitBillButton"
                          }
                        ],
                        staticStyle: { width: "120px" },
                        attrs: {
                          "controls-position": "right",
                          min: -999999999999,
                          max: 999999999999,
                          precision: 2,
                          disabled: true
                        },
                        model: {
                          value: _vm.billing.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "amount", $$v)
                          },
                          expression: "billing.amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": "left",
                        "label-width": _vm.isZh ? "100px" : "115px",
                        model: _vm.billing
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            padding: "2px 0"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AccountContacts")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Contact,
                                  "allow-create": true,
                                  filterable: "",
                                  cache: false,
                                  clearable: "",
                                  disabled: !_vm.unCommitOrPrint,
                                  "default-value": _vm.billing.accountContacts,
                                  "static-options": _vm.accountContactsArray
                                },
                                on: {
                                  parentCallBack: _vm.accountContactChangeEvent
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_AccountContactsTel"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: { disabled: !_vm.unCommitOrPrint },
                                model: {
                                  value: _vm.billing.accountContactsTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.billing,
                                      "accountContactsTel",
                                      $$v
                                    )
                                  },
                                  expression: "billing.accountContactsTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_AccountAddr") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: { disabled: !_vm.unCommitOrPrint },
                            model: {
                              value: _vm.billing.accountAddr,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "accountAddr", $$v)
                              },
                              expression: "billing.accountAddr"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.billing.billingType === "国外账单",
                              expression: "billing.billingType === '国外账单'"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("Billing.billingJob_settlementType")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "400px" },
                              attrs: { disabled: !_vm.unCommitOrPrint },
                              model: {
                                value: _vm.billing.settlementType,
                                callback: function($$v) {
                                  _vm.$set(_vm.billing, "settlementType", $$v)
                                },
                                expression: "billing.settlementType"
                              }
                            },
                            [
                              _vm.billing.settlementType === 0
                                ? _c("el-option", {
                                    key: -1,
                                    attrs: { label: " ", value: 0 }
                                  })
                                : _vm._e(),
                              _vm._l(_vm.SETTLEMENT_TYPE_STATES, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$store.getters.isZh
                                      ? item.chineseName
                                      : item.englishName,
                                    value: item.code
                                  }
                                })
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticStyle: { width: "10px", height: "100%" } }),
              _c(
                "div",
                {
                  staticStyle: {
                    "flex-grow": "1",
                    display: "flex",
                    "flex-direction": "column"
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": "left",
                        "label-width": _vm.isZh ? "90px" : "135px",
                        model: _vm.billing
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.AccountObject") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t("Message.PleaseSelect"),
                                disabled:
                                  !_vm.unCommitOrPrint &&
                                  !_vm.isBySettlementAgent,
                                size: "mini"
                              },
                              on: { change: _vm.accountCodeChangeEvent },
                              model: {
                                value: _vm.billing.accountId,
                                callback: function($$v) {
                                  _vm.$set(_vm.billing, "accountId", $$v)
                                },
                                expression: "billing.accountId"
                              }
                            },
                            _vm._l(_vm.billingChargeAccounts, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.data }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.settlementAgent") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "default-value": Number(
                                _vm.billing.settlementAgentId
                              ),
                              disabled:
                                !_vm.unCommitOrPrint || _vm.isBySettlementAgent,
                              cache: false,
                              "tag-name": "chineseName",
                              "static-options": _vm.settlementAgentArray
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.billing.settlementAgentId = p.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_InvoiceHeader")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.static_data_Title,
                              "allow-create": true,
                              filterable: "",
                              cache: false,
                              disabled: !_vm.unCommitOrPrint,
                              "default-value": _vm.invoiceTitleUuid,
                              "tag-value": "uuid",
                              "static-options": _vm.titleArray
                            },
                            on: { parentCallBack: _vm.titleChangeEvent }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Partners.CustomerMailbox") }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "customerEmail" },
                            model: {
                              value: _vm.billing.customerEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "customerEmail", $$v)
                              },
                              expression: "billing.customerEmail"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_DepositBank") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.static_data_TitleBank,
                              no: "8",
                              "default-value": _vm.titleBankUuid,
                              disabled: !_vm.unCommitOrPrint,
                              cache: false,
                              "tag-value": "uuid",
                              "static-options": _vm.titleBankArray
                            },
                            on: { parentCallBack: _vm.getBankCusFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BankAccount") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, no: "buyerBankAccount" },
                            model: {
                              value: _vm.billing.buyerBankAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "buyerBankAccount", $$v)
                              },
                              expression: "billing.buyerBankAccount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_OwnerBankOfDeposit")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              cache: false,
                              disabled: !_vm.unCommitOrPrint,
                              "select-type":
                                _vm.selectTypeNames.static_data_BankAccount,
                              "default-value":
                                _vm.billing.bankAccountId === 0
                                  ? ""
                                  : _vm.billing.bankAccountId,
                              "static-options": _vm.ourBankAccountArray
                            },
                            on: {
                              parentCallBack: _vm.getOurBankAccountFromChild
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BankAccount") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: !_vm.unCommitOrPrint },
                            model: {
                              value: _vm.billing.bankAccount,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "bankAccount", $$v)
                              },
                              expression: "billing.bankAccount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CounterPartyBillingNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: !_vm.unCommitOrPrint },
                            model: {
                              value: _vm.billing.counterPartyBillingNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.billing,
                                  "counterPartyBillingNo",
                                  $$v
                                )
                              },
                              expression: "billing.counterPartyBillingNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.InputDate") } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              clearable: false,
                              editable: false,
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              disabled: !_vm.unCommitOrPrint
                            },
                            on: { change: _vm.inputDateChange },
                            model: {
                              value: _vm.billing.inputDate,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "inputDate", $$v)
                              },
                              expression: "billing.inputDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              disabled: !_vm.unCommitOrPrint
                            },
                            model: {
                              value: _vm.billing.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.billing, "remark", $$v)
                              },
                              expression: "billing.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "justify-content": "center", "font-size": "30px" }
            },
            [
              _c("i", {
                class: _vm.expandedGrid
                  ? "el-icon-caret-top"
                  : "el-icon-caret-bottom",
                on: {
                  click: function($event) {
                    _vm.expandedGrid = !_vm.expandedGrid
                  }
                }
              })
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "justify-content": "space-between",
                "padding-left": "0"
              }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Add", type: "primary" },
                      on: { click: _vm.btnAddEventHandler }
                    },
                    [_vm._v(_vm._s(this.$t("SeaExport.AddBillCharge")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Remove",
                        disabled: !(
                          _vm.billing &&
                          !_vm.billing.billingGroupUuid &&
                          (_vm.billing.state === 0 ||
                            _vm.billing.state === -1 ||
                            (_vm.billing.state === 2 &&
                              !_vm.billing.confirmed)) &&
                          (!_vm.billing.invoiceState ||
                            _vm.billing.invoiceState === 0) &&
                          (!_vm.billing.realClearingState ||
                            _vm.billing.realClearingState ===
                              _vm.ClearingConstants.CLEARING_STATE_NON.code)
                        ),
                        type: "primary"
                      },
                      on: { click: _vm.removeBillChargeEvent }
                    },
                    [_vm._v(_vm._s(this.$t("SeaExport.RemoveBillCharge")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.chkShowLclVisible,
                          expression: "chkShowLclVisible"
                        }
                      ],
                      staticStyle: { "margin-left": "10px" },
                      on: { change: _vm.chkChangeHandler },
                      model: {
                        value: _vm.chkShowLclSelected,
                        callback: function($$v) {
                          _vm.chkShowLclSelected = $$v
                        },
                        expression: "chkShowLclSelected"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ShowLcl")))]
                  ),
                  _vm._l(_vm.instructionBtns, function(item, index) {
                    return [
                      _c(
                        "el-button",
                        {
                          key: index,
                          style: { marginLeft: index === 0 ? "5px" : "" },
                          attrs: {
                            no: item.platformInstructionRuleCode,
                            type: _vm.getInstructionBtnType(item),
                            disabled: !item.allowOperate
                          },
                          on: {
                            click: function($event) {
                              return _vm.onInstructionClick(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.getInstructionLabel(item)) + " "
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-left": "0" }
            },
            [
              _c("cargo-ag-grid", {
                style: {
                  width: "100%",
                  height: _vm.expandedGrid ? "" : "571px"
                },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.billing.charge
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.splitBillButton
                ? _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.nowPage === 0, type: "primary" },
                      on: { click: _vm.theLastPageHandler }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Invoice.invoice_theLastPage")) +
                          " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.splitBillButton
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled:
                          _vm.nowPage === _vm.splitCurrencyList.length - 1,
                        type: "primary"
                      },
                      on: { click: _vm.theNextPageHandler }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Invoice.invoice_theNextPage")) +
                          " "
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_billTab_invoiceFromBilling"],
                      expression: "['button_billTab_invoiceFromBilling']"
                    }
                  ],
                  attrs: {
                    disabled: _vm.applyInvoiceDisabled,
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onApplyInvoiceClick(_vm.billing)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Billing.ApplyForInvoicing")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "Save",
                    type: "primary",
                    disabled: _vm.btnSaveEnable
                  },
                  on: { click: _vm.saveBilling }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "0" },
                  attrs: { no: "Cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              ),
              _vm.splitBillButton
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "padding-right": "5px",
                        "padding-left": "5px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.nowPage + 1 + "/" + _vm.splitCurrencyList.length
                        )
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.showJoinChargeDialog
            ? _c("join-charge-dialog", {
                attrs: {
                  visible: _vm.showJoinChargeDialog,
                  "search-item-module": _vm.searchItemModule,
                  "default-conditions": _vm.addChargeCondition
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showJoinChargeDialog = $event
                  },
                  addChargeCallBackEvent: _vm.selectedChargeEvent
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: _vm.checkingSaveJobWindow.lob,
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.billEditChargeDialog.visible
        ? _c("bill-edit-charge-dialog", {
            attrs: {
              visible: _vm.billEditChargeDialog.visible,
              title: _vm.billEditChargeDialog.title,
              "simple-jobs": _vm.billEditChargeDialog.simpleJobs,
              job: _vm.job,
              charge: _vm.billEditChargeDialog.charge,
              "currency-list": _vm.billEditChargeDialog.currencyList,
              billing: _vm.billing,
              "split-bill": _vm.splitBillButton
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.billEditChargeDialog, "visible", $event)
              },
              callback: _vm.saveBillEditChargeCallback
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }